import Service from '@ember/service';
import * as SvgUtils from '../utils/svg-utils';

/**
 * Maintain a custom style element that can be edited
 * from the code.
 * It would be better practice to add classes to app.less
 * and add/remove those classes in the code.  However,
 * this provides the ability to add custom heights/widths
 */

export default class AdiStyleService extends Service {
  rules = []; // Maintain list of rule objects for easy access

  constructor() {
    super(...arguments);

    let styleElement = document.createElement('style');
    document.head.appendChild(styleElement);

    this.styleElement = styleElement;
  }

  insertRule(rule) {
    // see if the rule already exists
    let existingRule = this.getRuleForSelector(rule.selector);

    // Override existing properties if the rule exists, otherwise add the rule
    if (existingRule) existingRule.properties = Object.assign({}, existingRule.properties, rule.properties);
    else this.rules.push(rule);

    SvgUtils.modifyStyleElement(this.rules, this.styleElement);
  }

  removeRuleForSelectors(selectors) {
    this.rules = this.rules.filter((rule) => !selectors.includes(rule.selector));
    SvgUtils.modifyStyleElement(this.rules, this.styleElement);
  }

  getRuleForSelector(selector) {
    return this.rules.find((rule) => rule.selector === selector);
  }

  getValueForSelectorProperty(selector, propertyName) {
    let rule = this.getRuleForSelector(selector);
    return rule && rule.properties && propertyName in rule.properties ? rule.properties[propertyName] : null;
  }
}
